import { render } from "./ListByReport.vue?vue&type=template&id=461a20a6&ts=true"
import script from "./ListByReport.vue?vue&type=script&lang=ts"
export * from "./ListByReport.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/prod/fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__